export const environment = {
  production: false,
  apiUrl: 'https://api.vigilantpass.dev'
};
